import * as axios from 'axios';
import {
    createRequestId,
    format,
    getUrlStrs,
    isProductionEnv,
    isWebPageFileOpen,
    isLocalDev
} from './Utils.js';
import {bridge} from './Bridge.js';
import {DataStruct} from './DataStruct.js';
import {BOM} from './BOM.js';
//
const EXPIRETIME = 10000;
axios.defaults.withCredentials = true;
axios.defaults.timeout = 90000;
const CancelToken = axios.CancelToken;
const defaultcancelRefer = {};//用于请求的取消
//异常提示
const Error = {
    EVENT: 'web_network_error',
    LOCALNETWORKERROR: 'local_network',
    SERVERRESPONSEERROR: 'server_response',
    HTTPERROR: 'server_response_http',
    JSONERROR: 'server_response_json_format',
    USERERROR: 'local_callback',
    MSG: 'サイバーとの接続が切られましたので、もう一度ログインしてお試しください',
    LOCALMSG: 'ネット環境が不安定です、あとでもう一度やり直してください。',
    EXPIRE: 'server_response_expire'
};
//
function _format(param) {
    let s = [];
    for (let j in param) {
        s.push(encodeURIComponent(j) + '=' + encodeURIComponent(param[j]));
    }
    let result = s.join('&').replace(/%20/g, '+');
    return result === '' ? result : '&' + result;
}
//存储每个请求允许请求次数的信息
const _request_store = {};
//本地网络错误处理
function wrapLocalNetWorkError(key, originOptions, options, e,logAction,request) {
    const _cache = _request_store[key];
    //重试
    if (_cache.count != 0 && options.needRetry) {
        _cache.count--;
        originOptions.key = key;
        //10秒钟后重试
        setTimeout(function () {
            request(originOptions);
        }, 10000);
    } else {
        _request_store[key] = null;
        options.error(2, {response: {data: {err_code: 0, err_msg: Error.LOCALMSG}}}); //local network error
        //网络错误回调
        options.netWorkErrorCallback();
        if (options.log) {
            logAction({
                label: Error.LOCALNETWORKERROR,
                extra: {
                    api: originOptions.url,
                    content: (e && e.code) || 'weak_lan'
                }
            });
        }
    }
}
//服务端返回的格式
const responseFormat = {
    err_code: 0,
    err_msg: '',
    data: {}
};
//回调
function wrapCallBack(option, api, response, cb,logAction) {
    if (response.data instanceof Object) {
        //是否需要约束,如果添加约束，则会根据约束返回值
        //假设q:{ 'a':0,'b':0,'c':0 } 实际server 的返回值为 { 'a':1,'b':1 } 则实际返给调用函数的值为 { 'a':1,'b':1,'c':0 }
        if (option.q) {
            const _q = {
                ...responseFormat,
                data: option.q
            };
            cb(DataStruct.extend(response.data, _q));
        } else {
            cb(response.data);
        }
        //err_code不为0 进行上报
        if (response.data.err_code && option.log) {
            logAction({
                label: Error.SERVERRESPONSEERROR,
                extra: {
                    content: response.data.err_msg,
                    api: api,
                    params:option.data
                }
            });
        }
    } else {
        //说明服务端返回的非json的数据，上报
        if (option.log) {
            logAction({
                label: Error.JSONERROR,
                extra: {
                    content: response.data,
                    api: api,
                    params:option.data
                }
            });
            BOM.alert(Error.MSG);
        }
    }
    option.expired = false;
}
//http error 处理 (http code 不为 200)
function wrapHttpError(e, option, o_option, key, cb,logAction,request) {
    if (e.response) {
        if (e.response.data && e.response.data instanceof Object) {
            //走正常的callback流程，callback要对 err_msg 进行处理
            cb(e.response.data);
        } else {
            //http 异常 加 非json格式
            option.error(1, e, option);
        }
        if (option.log) {
            logAction({
                label: Error.HTTPERROR,
                extra: {
                    api: o_option.url,
                    content: e.response.status || 200,
                    msg: e.response.data || '',
                    params:option.data
                }
            });
        }
    } else {
        //没有response 代表服务端没有返回，超时或者是本地网络错误或者跨域限制
        if (option.needNetworkError) {
            wrapLocalNetWorkError(key, o_option, option, e,logAction,request);
        }
    }
    option.expired = false;
}

//回调函数里的异常,直接上报
function wrapUserError(e, option, api,logException) {
    //回调函数异常
    option.error(3, e, option);
    if (option.log) {
        logException(e, api);
    }
    option.expired = false;
}

/*
* config
* {
* baseUrl:String,
* testBaseUrl:String,
* isTestEnv:Boolean,
* debugRequest:Function,
* debugResponse:Function,
* env:String,
* sendLog:Function,
* isNative:Boolean,
* allowNativeRequest:Boolean,
* apiBlockCollection:Object,
* handleRequestHeader:Function,
* logException:Function,
* parametersDict:Object,
* parameters:Object,
* mockBaseUrl:String
* }
* */

function createRequest(config) {
    //
    const baseUrl = config.baseUrl;
    const testBaseUrl = config.testBaseUrl;
    const mockBaseUrl = config.mockBaseUrl;
    const isTestEnv = config.isTestEnv;
    const _env = config.env;
    const _log = config.sendLog;
    const debugRequest = config.debugRequest;
    const debugResponse = config.debugResponse;
    const logException = config.logException;
    const isNative = config.isNative;
    const allowNativeRequest = config.allowNativeRequest;
    const apiBlockCollection = config.apiBlockCollection;
    const handleRequestHeader = config.handleRequestHeader;
    const _parametersDict = config.parametersDict;
    const _parameters = config.parameters;
    //
    const request=function (options, cancelRefer) {
        if (!options.url) {
            throw 'url required';
        }
        const _cancelRefer = cancelRefer || defaultcancelRefer;
        const _options = {
            proxy: false, //是否启用客户端代理
            proxyBaseUrl: '',
            headers: {},
            mark: {},
            encrypted: false, //是否需要加密发送
            gzip: false,
            method: 'get',
            crossOrigin: true,
            json: false,
            q: null, //如果有传入json,用来约束返回数据的格式
            log: true, //异常时是否发送log
            needRetry: true, //网络错误重试，为false仅处理一次
            needNetworkError: true, //为false 则不会处理网络错误
            netWorkErrorCallback: () => {
            },
            baseUrl: baseUrl,
            testBaseUrl: testBaseUrl,
            env: _env || 'dev',
            callback: () => {
            },
            error: (status, e) => {
                //处理非业务的异常1 http 异常 加 非json格式  2 网络错误  3 业务
                if (e.response) {
                    try {
                        if (e.response.data.err_msg) {
                            BOM.alert(e.response.data.err_msg);
                        } else {
                            //非json格式,直接输出，方便调试
                            BOM.log(e);
                            BOM.alert(Error.MSG);
                        }
                    } catch (e) {
                        BOM.log(e);
                        BOM.alert(Error.MSG);
                    }
                } else {
                    //程序异常
                    BOM.log(e);
                    BOM.alert(Error.MSG);
                }
            },
            data: {},
            expired: true,
            mock: false,
            mockDataUrl: '',
            ...options
        };
        //上报超长请求的异常
        setTimeout(() => {
            if (_options.expired) {
                _log({
                    label: Error.EXPIRE,
                    extra: {
                        api: api
                    }
                });
            }
        }, EXPIRETIME);
        //请求端唯一标示
        const _key = _options.key || createRequestId();
        const urlArray = _options.url.split('?');
        const api = urlArray[0];
        const params = urlArray[1];
        const proxyApi = apiBlockCollection[api];
        const needQ_sign = !!proxyApi;
        //const needQ_sign =false;
        //启用客户端代理
        if (needQ_sign || _options.proxy || isWebPageFileOpen()) {
            if (isNative && allowNativeRequest) {
                const _init = {
                    method: _options.method,
                    data: {..._options.data},
                    timeout: axios.defaults.timeout / 1000,
                    headers: _options.headers,
                    gzip: _options.gzip,
                    mark: _options.mark
                };
                if (_options.json) {
                    _init.encoding = 'json';
                }
                if (_options.needRetry) {
                    _init.retry = 3;
                }
                if (_options.encrypted) {
                    _init.mark.hash_type = 1;
                }
                _cancelRefer['cancel'] = () => {
                    bridge.post('cancel_request', {id: _key});
                };
                //去除重复参数，当data 里的参数 与 querystring 里的冲突时以data里为主
                let parameters =format(_parametersDict.dynamic || {});
                if (_options.method.toLowerCase() === 'get') {
                    const apiParamsDict = getUrlStrs(_options.url);
                    if (Object.keys(_init.data).length != 0) {
                        const paramDict = DataStruct.extend((_parametersDict.dynamic || {}));
                        for (let o in _init.data) {
                            paramDict[o] && delete paramDict[o];
                            apiParamsDict[o] && delete _init.data[o];
                        }
                        parameters = format(paramDict);
                    }
                }
                _options.url =
                    _options.url.indexOf('?') === -1
                        ? _options.url + '?request_refer=native_proxy&'+parameters
                        : _options.url + '&request_refer=native_proxy&'+parameters;
                const _pdata = {
                    init: _init,
                    id: _key
                };
                if (_options.proxyBaseUrl) {
                    _pdata.url = _options.proxyBaseUrl + _options.url;
                } else {
                    _pdata.api_path = _options.url;
                }
                bridge.post(
                    'request',
                    {
                        ..._pdata
                    },
                    (parameters, error) => {
                        _options.expired = false;//
                        if (error) {
                            BOM.alert(error.code);
                            return;
                        }
                        const data = parameters.json;
                        //
                        if (data instanceof Object) {
                            if (_options.q) {
                                const _q = {
                                    ...responseFormat,
                                    data: _options.q
                                };
                                _options.callback(DataStruct.extend(data, _q));
                            } else {
                                _options.callback(data);
                            }
                            if (data.err_code && _options.log) {
                                _log({
                                    label: Error.SERVERRESPONSEERROR,
                                    extra: {
                                        content: data.err_msg,
                                        api: options.url,
                                        native_proxy: 1
                                    }
                                });
                            }
                        } else {
                            if (_options.log) {
                                _log({
                                    label: Error.JSONERROR,
                                    extra: {
                                        content: data,
                                        api: options.url,
                                        native_proxy: 1
                                    }
                                });
                                BOM.alert(Error.MSG);
                            }
                        }
                    }
                );
                return;
            } else {
                if (proxyApi) {
                    _options.url = proxyApi + (params ? '?' + params : '');
                }
            }
        }
        const callback = data => {
            debugResponse(_options.url, data);
            _options.callback(data);
        };
        //去除重复参数，当data 里的参数 与 querystring 里的冲突时以data里为主
        let parameters = _parameters;
        if (_options.method.toLowerCase() === 'get') {
            if (Object.keys(_options.data).length != 0) {
                const apiParamsDict = getUrlStrs(_options.url);
                const paramDict = DataStruct.extend(_parametersDict);
                for (let o in _options.data) {
                    paramDict[o] && delete paramDict[o];
                    apiParamsDict[o] && delete _options.data[o];
                }
                parameters = format(paramDict);
            }
        }
        //初始化，每个请求额外三次机会
        !_options.key && (_request_store[_key] = {count: 3});
        //添加key参数
        _options.url =
            _options.url.indexOf('?') === -1
                ? _options.url + '?request_id=' + _key
                : _options.url + '&request_id=' + _key;
        //判断是不是重试请求，如果是，将参数添加到参数上
        _options.retry && (_options.url = _options.url + '&retry=1');
        _options.url = _options.url + '&' + parameters;
        if (_options.mock) {
            axios.defaults.withCredentials = false;
            _options.json = false;
            if (_options.mockDataUrl) {
                _options.url = _options.mockDataUrl + '?' + _options.url.split('?')[1];
            }
            if (!_parametersDict.local_mock) {
                _options.url = mockBaseUrl + _options.url;
            }
        } else {
            if(_options.crossOrigin) {
                if (!isProductionEnv()) {
                    if(isLocalDev()){
                        _options.testBaseUrl = "";
                    } else if(isTestEnv){
                        _options.testBaseUrl = _options.testBaseUrl.replace("https","http");
                    }
                    _options.baseUrl = _options.testBaseUrl;
                }
                _options.url = _options.baseUrl + _options.url;
            }
            debugRequest(_options.url);
        }
        //发起请求
        if (_options.method.toLowerCase() === 'post') {
            const _postOption = {
                method: 'post',
                url: _options.url,
                data: _options.data,
                cancelToken: new CancelToken(function executor(c) {
                    _cancelRefer['cancel'] = c;
                }),
                headers: _options.headers
            };
            if (!_options.json) {
                _postOption.transformRequest = [
                    function (data) {
                        // 对 data 进行任意转换处理
                        return _format(data);
                    }
                ];
                _postOption.headers['Content-Type'] =
                    'application/x-www-form-urlencoded; charset=UTF-8';
            }
            handleRequestHeader(_postOption.headers);
            return axios(_postOption)
                .then(function (response) {
                    try {
                        wrapCallBack(_options, options.url, response, callback,_log);
                    } catch (e) {
                        wrapUserError(e, _options, options.url,logException);
                    }
                })
                .catch(function (e) {
                    wrapHttpError(e, _options, options, _key, callback,_log,request);
                });
        } else {
            const headers = _options.headers;
            handleRequestHeader(headers);
            return axios
                .get(_options.url + _format(_options.data), {
                    cancelToken: new CancelToken(function executor(c) {
                        _cancelRefer['cancel'] = c;
                    }),
                    headers: headers
                })
                .then(function (response) {
                    try {
                        wrapCallBack(_options, options.url, response, callback,_log);
                    } catch (e) {
                        wrapUserError(e, _options, options.url,logException);
                    }
                })
                .catch(function (e) {
                    wrapHttpError(e, _options, options, _key, callback,_log,request);
                });
        }
    };
    return request;
}
//
export {createRequest, axios, defaultcancelRefer, Error};
